import './index.scss'
import { BackIcon } from "../icons";

const Back = ({ back }) => {
  return (
    <span className="btn-back" onClick={() => back()}>
      <BackIcon />
    </span>
  );
}

export default Back;
